export function isOrderOpen(status, brokerage) {
  const openArr = [
    'open',
    'partially_filled',
    'pending',
    'calculated',
    'accepted_for_bidding',
    'held',
    'in_flight',
    'live',
  ];
  return openArr.includes(`${status ?? ''}`.toLowerCase());
}
